(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const freeShippingThreshold = 5999;

  const header = $('[data-smart-header]');
  let lastY = window.scrollY;
  let ticking = false;
  const updateHeader = () => {
    const y = window.scrollY;
    const delta = y - lastY;
    if (y < 24 || delta < -7) header?.classList.remove('is-hidden');
    else if (y > 130 && delta > 7) header?.classList.add('is-hidden');
    lastY = y;
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; } }, { passive: true });

  const menu = $('[data-mobile-menu]');
  const menuScrim = $('[data-menu-scrim]');
  const setMenu = (open) => {
    menu?.classList.toggle('is-open', open);
    menu?.setAttribute('aria-hidden', String(!open));
    if (menuScrim) { menuScrim.hidden = !open; menuScrim.classList.toggle('is-open', open); }
    document.body.classList.toggle('drawer-locked', open);
  };
  $('[data-menu-open]')?.addEventListener('click', () => setMenu(true));
  $('[data-menu-close]')?.addEventListener('click', () => setMenu(false));
  menuScrim?.addEventListener('click', () => setMenu(false));

  const searchToggle = $('[data-search-toggle]');
  const searchPanel = $('[data-search-panel]');
  searchToggle?.addEventListener('click', () => {
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) $('input', searchPanel)?.focus();
  });

  $('[data-collection-sort]')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.assign(url.toString());
  });

  const productRoot = $('[data-product-root]');
  if (productRoot) {
    const variantInput = $('[data-variant-input]', productRoot);
    const price = $('[data-product-price]', productRoot);
    const image = $('[data-product-image]', productRoot);
    const sku = $('[data-variant-sku]', productRoot);
    const selected = $('[data-selected-variant]', productRoot);
    const addLabel = $('[data-add-label]', productRoot);
    const addButton = $('.add-to-cart', productRoot);
    const chooseVariant = (button) => {
      const id = button.dataset.variantChoice;
      $$('[data-variant-choice]', productRoot).forEach((item) => item.classList.toggle('active', item === button));
      $$('[data-variant-thumb]', productRoot).forEach((item) => item.classList.toggle('active', item.dataset.variantThumb === id));
      variantInput.value = id;
      price.textContent = button.dataset.price;
      image.src = button.dataset.image;
      if (sku) sku.textContent = button.dataset.sku || '—';
      if (selected) selected.textContent = button.textContent.trim().replace(button.dataset.price, '').trim();
      addLabel.textContent = `Add to cart · ${button.dataset.price}`;
      addButton.disabled = button.dataset.available !== 'true';
      image.animate?.([{ opacity: .35, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 340, easing: 'cubic-bezier(.2,.8,.2,1)' });
    };
    $$('[data-variant-choice]', productRoot).forEach((button) => button.addEventListener('click', () => chooseVariant(button)));
    $$('[data-variant-thumb]', productRoot).forEach((button) => button.addEventListener('click', () => {
      const choice = $(`[data-variant-choice="${button.dataset.variantThumb}"]`, productRoot);
      if (choice) chooseVariant(choice);
    }));
    const quantity = $('[data-quantity]', productRoot);
    const changeProductQuantity = (direction) => {
      const next = Math.max(1, Number(quantity.value || 1) + direction);
      if (next === Number(quantity.value)) return;
      quantity.value = next;
      if (!reduceMotion) quantity.animate(
        [{ opacity: .3, transform: `translateY(${direction > 0 ? '7px' : '-7px'}) scale(.9)` }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
        { duration: 280, easing: 'cubic-bezier(.2,.85,.25,1)' }
      );
    };
    $('[data-qty-minus]', productRoot)?.addEventListener('click', () => changeProductQuantity(-1));
    $('[data-qty-plus]', productRoot)?.addEventListener('click', () => changeProductQuantity(1));
  }

  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-cart-scrim]');
  const cartContent = $('[data-cart-content]');
  let cartOpen = false;
  let dragging = null;
  let drawerX = 0;
  let previousShippingProgress = 0;
  const assetFor = (item) => window.DearLumo?.assets?.[item.sku] || item.image || window.DearLumo?.assets?.[item.handle] || '';
  const shippingProgressMarkup = (cart) => {
    const remaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const progress = Math.min(1, cart.total_price / freeShippingThreshold);
    const message = remaining > 0
      ? `You're <strong>${formatMoney(remaining)}</strong> away from free shipping`
      : `<strong>Free shipping unlocked!</strong> Your gift is ready to travel.`;
    return `<section class="shipping-progress ${remaining === 0 ? 'is-complete' : ''}" aria-label="Free shipping progress"><div class="shipping-progress-copy"><span>${remaining === 0 ? '✓' : '🚚'}</span><p>${message}</p><small>${formatMoney(cart.total_price)} / $59.99</small></div><div class="shipping-meter"><span data-shipping-fill style="transform:scaleX(${progress})"></span></div></section>`;
  };
  const animateCartFeedback = (cart, direction = 0) => {
    const progress = Math.min(1, cart.total_price / freeShippingThreshold);
    const fill = $('[data-shipping-fill]', cartContent);
    if (fill && !reduceMotion) {
      fill.animate(
        [{ transform: `scaleX(${previousShippingProgress})` }, { transform: `scaleX(${progress})` }],
        { duration: 520, easing: 'cubic-bezier(.2,.82,.2,1)', fill: 'both' }
      );
    }
    const value = $('.quantity-value', cartContent);
    if (value && direction && !reduceMotion) value.animate(
      [{ opacity: .25, transform: `translateY(${direction > 0 ? '8px' : '-8px'}) scale(.86)` }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
      { duration: 300, easing: 'cubic-bezier(.2,.9,.25,1)' }
    );
    if (cart.total_price >= freeShippingThreshold && previousShippingProgress < 1 && !reduceMotion) {
      $('.shipping-progress', cartContent)?.animate(
        [{ transform: 'scale(.985)' }, { transform: 'scale(1.018)' }, { transform: 'scale(1)' }],
        { duration: 520, easing: 'cubic-bezier(.2,.9,.25,1)' }
      );
    }
    previousShippingProgress = progress;
  };
  const setDrawerX = (x) => {
    const width = drawer?.offsetWidth || 500;
    drawerX = Math.max(0, Math.min(width, x));
    drawer.style.transform = `translate3d(${drawerX}px,0,0)`;
    scrim.style.opacity = String(Math.max(0, 1 - drawerX / width));
  };
  const springTo = (target, done) => {
    if (reduceMotion) { setDrawerX(target); done?.(); return; }
    let velocity = 0;
    let position = drawerX;
    let previous = performance.now();
    const frame = (now) => {
      const dt = Math.min(32, now - previous) / 1000;
      previous = now;
      const force = (target - position) * 280;
      velocity = (velocity + force * dt) * Math.pow(.74, dt * 60);
      position += velocity * dt;
      setDrawerX(position);
      if (Math.abs(target - position) < .6 && Math.abs(velocity) < 8) { setDrawerX(target); done?.(); return; }
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  };
  const renderCart = (cart, direction = 0) => {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.classList.remove('count-pop'); void node.offsetWidth; node.classList.add('count-pop'); });
    $('[data-drawer-count]').textContent = `(${cart.item_count})`;
    if (!cart.items.length) {
      cartContent.innerHTML = `${shippingProgressMarkup(cart)}<div class="drawer-empty"><div class="empty-cart-icon">🛍</div><h3>Your cart is empty</h3><p>Add $59.99 in gifts to unlock free shipping.</p><a class="primary-button" href="/collections/halloween">Shop Halloween Gifts →</a></div>`;
      animateCartFeedback(cart, direction);
      return;
    }
    cartContent.innerHTML = `${shippingProgressMarkup(cart)}<section class="drawer-items">${cart.items.map((item, index) => `<article class="drawer-item"><img src="${assetFor(item)}" alt=""><div class="drawer-item-info"><h3>${item.product_title}</h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-variant">${item.variant_title}${item.sku ? ` · ${item.sku}` : ''}</p>` : ''}<p class="gift-ready">🎁 Gift-ready packaging included</p><div class="drawer-item-bottom"><div class="quantity-control"><button type="button" data-line-change="${index + 1}" data-qty="${Math.max(0, item.quantity - 1)}" data-direction="-1" aria-label="Decrease quantity">−</button><span class="quantity-value">${item.quantity}</span><button type="button" data-line-change="${index + 1}" data-qty="${item.quantity + 1}" data-direction="1" aria-label="Increase quantity">+</button></div><button class="remove-button" type="button" data-line-change="${index + 1}" data-qty="0" data-direction="-1">Remove</button><strong>${formatMoney(item.final_line_price)}</strong></div></div></article>`).join('')}</section><div class="drawer-summary"><div class="summary-row"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div><p>Shipping and taxes calculated at checkout.</p><a class="checkout-button" href="/checkout">Checkout securely →</a><div class="summary-trust">▣ Secure checkout · Easy order support</div><div class="delivery-note"><span>🎁</span><div><strong>Packed with care</strong><span>Every DearLumo gift is checked before dispatch.</span></div></div></div>`;
    animateCartFeedback(cart, direction);
    $$('[data-line-change]', cartContent).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      button.classList.add('is-pressed');
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.lineChange), quantity: Number(button.dataset.qty) }) });
      renderCart(await response.json(), Number(button.dataset.direction || 0));
    }));
  };
  const refreshCart = async () => { const response = await fetch('/cart.js'); const cart = await response.json(); renderCart(cart); return cart; };
  const openCart = async () => {
    await refreshCart();
    cartOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    document.body.classList.add('drawer-locked');
    setDrawerX(drawer.offsetWidth);
    springTo(0);
  };
  const closeCart = () => springTo(drawer.offsetWidth, () => {
    cartOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    document.body.classList.remove('drawer-locked');
  });
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $('[data-cart-close]')?.addEventListener('click', closeCart);
  scrim?.addEventListener('click', closeCart);
  $('[data-cart-drag]')?.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button')) return;
    dragging = { start: event.clientX, x: drawerX };
    event.currentTarget.setPointerCapture(event.pointerId);
  });
  $('[data-cart-drag]')?.addEventListener('pointermove', (event) => { if (dragging) setDrawerX(dragging.x + event.clientX - dragging.start); });
  $('[data-cart-drag]')?.addEventListener('pointerup', () => { if (!dragging) return; const shouldClose = drawerX > drawer.offsetWidth * .34; dragging = null; shouldClose ? closeCart() : springTo(0); });

  const addVariant = async (id, quantity = 1) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) });
    if (!response.ok) throw new Error('Unable to add this item');
    await openCart();
  };
  $$('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.quickAdd); } finally { button.disabled = false; }
  }));
  $$('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = $('button[type="submit"]', form);
    submit.disabled = true;
    try { await addVariant($('[name="id"]', form).value, Number($('[name="quantity"]', form).value || 1)); submit.classList.add('added'); setTimeout(() => submit.classList.remove('added'), 1000); } finally { submit.disabled = false; }
  }));

  addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (cartOpen) closeCart();
    setMenu(false);
    if (searchPanel) searchPanel.hidden = true;
  });
  refreshCart().catch(() => {});
})();
